import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import apiClient from '../api/client';
import { getSessionToken } from './session';

const PermissionsContext = createContext({
  role: null,
  permissions: [],
  loading: false,
  hasPermission: () => false,
  refreshPermissions: () => Promise.resolve(),
});

export function PermissionsProvider({ children }) {
  const [role, setRole] = useState(null);
  const [permissions, setPermissions] = useState([]);
  const [loading, setLoading] = useState(!!getSessionToken());

  const refreshPermissions = useCallback(async () => {
    if (!getSessionToken()) {
      setRole(null);
      setPermissions([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const { data } = await apiClient.get('/users/me/permissions');
      setRole(data.role || null);
      setPermissions(Array.isArray(data.permissions) ? data.permissions : []);
    } catch (error) {
      console.error('Error al cargar los permisos:', error);
      setRole(null);
      setPermissions([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshPermissions();
  }, [refreshPermissions]);

  const value = useMemo(() => ({
    role,
    permissions,
    loading,
    hasPermission: (permission) => permissions.includes(permission),
    refreshPermissions,
  }), [role, permissions, loading, refreshPermissions]);

  return (
    <PermissionsContext.Provider value={value}>
      {children}
    </PermissionsContext.Provider>
  );
}

export function usePermissions() {
  return useContext(PermissionsContext);
}
